import React from 'react'
import { createPortal } from 'react-dom'
import { HiDuplicate } from 'react-icons/hi'

function ExportModal({
  show,
  selectedCount,
  pollName,
  setPollName,
  loading,
  onClose,
  onExport
}) {
  if (!show) return null

  return createPortal(
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10000,
        animation: 'fade-in 0.2s ease-out'
      }}
      onClick={onClose}
    >
      <div
        style={{
          backgroundColor: 'var(--bg-primary)',
          borderRadius: 'var(--radius-lg)',
          border: '1px solid var(--border-color)',
          boxShadow: 'var(--shadow-xl)',
          padding: '2rem',
          maxWidth: '500px',
          width: '90%',
          maxHeight: '90vh',
          overflow: 'auto',
          animation: 'slide-in 0.3s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{
          margin: '0 0 1.5rem 0',
          fontSize: '1.5rem',
          fontWeight: '700',
          color: 'var(--text-primary)',
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <HiDuplicate style={{ fontSize: '1.5rem', color: 'var(--accent-primary)' }} />
          Create New Poll
        </h2>

        <p style={{
          margin: '0 0 1.5rem 0',
          color: 'var(--text-secondary)',
          fontSize: '1rem'
        }}>
          Create a new poll with {selectedCount} selected choice{selectedCount !== 1 ? 's' : ''}. Enter a name for the new poll below.
        </p>

        <form onSubmit={(e) => {
          e.preventDefault()
          onExport()
        }}>
          <div className="form-group" style={{ marginBottom: '2rem' }}>
            <label
              htmlFor="clone-poll-name"
              style={{
                display: 'block',
                marginBottom: '0.5rem',
                fontWeight: '600',
                color: 'var(--text-primary)',
                fontSize: '1rem'
              }}
            >
              Poll Name *
            </label>
            <input
              id="clone-poll-name"
              type="text"
              className="form-input"
              placeholder="Enter poll name..."
              value={pollName}
              onChange={(e) => setPollName(e.target.value)}
              maxLength={150}
              disabled={loading}
              style={{
                width: '100%',
                padding: '0.75rem',
                fontSize: '1rem',
                borderRadius: 'var(--radius-md)',
                border: '1px solid var(--border-color)',
                backgroundColor: 'var(--bg-secondary)',
                color: 'var(--text-primary)'
              }}
            />
            {pollName.length > 140 && (
              <div style={{
                marginTop: '0.5rem',
                fontSize: '0.875rem',
                color: 'var(--warning-color)'
              }}>
                {150 - pollName.length} characters remaining
              </div>
            )}
          </div>

          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'flex-end',
            flexWrap: 'wrap'
          }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
              disabled={loading}
              style={{
                minWidth: '100px',
                padding: '0.75rem 1.5rem'
              }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={`btn btn-primary ${loading ? 'btn-loading' : ''}`}
              disabled={!pollName.trim() || loading}
              style={{
                minWidth: '100px',
                padding: '0.75rem 1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <HiDuplicate style={{ fontSize: '1rem' }} />
              {loading ? 'Creating...' : 'Create Poll'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  )
}

export default ExportModal
